import { jwtDecode } from "jwt-decode";
import { getEncryptedItem } from "./crypto";
import { ensureValidToken, isTokenExpired as isTokenExpiredManager } from "./token-manager";

const roleLevel = ['admin', 'brand', 'artist', 'influencer', 'user'];

// export function isTokenExpired(accessToken: string | null) {
//     if (!accessToken) {
//         return true;
//     }
//     try {
//         const tokenPayload = JSON.parse(atob(accessToken.split('.')[1]));
//         const currentTime = Math.floor(Date.now() / 1000);

//         return tokenPayload.exp <= currentTime;
//     } catch (err: any) {
//         console.error("Invalid token:", err);
//         return true;
//     }
// }

// 개선된 ABC 토큰 가져오기 함수 (토큰 관리자 사용)
export async function getAbcToken(): Promise<string | null> {
    try {
        return await ensureValidToken();
    } catch (error) {
        console.error('Error getting ABC token:', error);
        return null;
    }
}

// 동기 버전 (기존 코드와의 호환성을 위해)
export function getAbcTokenSync(): string | null {
    return localStorage.getItem('abc-auth-token');
}

// 토큰이 유효한지 확인하고 필요시 refresh
export async function getValidAbcToken(): Promise<string | null> {
    return await ensureValidToken();
}

// 토큰 만료 확인 (토큰 관리자 사용)
export function isAbcTokenExpired(): boolean {
    const token = getAbcTokenSync();
    return token ? isTokenExpiredManager(token) : true;
}

export function getToken(): string | undefined | null {
    return localStorage.getItem('auth-token');
}

// 동기 버전 (기존 코드와의 호환성을 위해)
export function getFsTokenSync(): string | undefined | null {
    return localStorage.getItem('abc-auth-token');
}

export async function getDevicePassword(): Promise<string | null> {
    return await getEncryptedItem('abc-device-password');
}

export async function getSignatureInfo(): Promise<any | null> {
    const signatureInfo = await getEncryptedItem('abc-signature-info');
    return signatureInfo ? JSON.parse(signatureInfo) : null;
}

export function getUserInfo() {
    const token = getToken();
    if (token) {
        try {
            return jwtDecode(token);
        } catch (err) {
            console.error('Invalid token:', err);
            return null;
        }
    }
    return null;
}

export function getUserUUID(): string | undefined | null {
    const jwt = getUserInfo();
    if (jwt) {
        const uuid = jwt.sub;
        return uuid;
    }
    return null;
}

export function getUserRoles(): string[] | null{
    const userInfo = getUserInfo() as any;
    if (userInfo) {
        return userInfo['https://hasura.io/jwt/claims']?.['x-hasura-allowed-roles'];
    } else {
        return null;
    }
}

export function getUserTopRole(): string | null {
    let topRole = null;
    const roleList = getUserRoles();

    if (!roleList) return null;

    for (let level = 0; level < roleLevel.length; level++) {
        for (let role = 0; role < roleList.length; role++) {
            if (roleLevel[level] === roleList[role]) {
                topRole = roleList[role];
                break;
            }
        }
        if (topRole != null) {
            break;
        }
    }

    return topRole;
}